import * as actionType from './types';
import axios from '../../../common/config/axios';

export const getList = (props) => dispatch => 
{
    axios.get('agent_commission/list', {params: props})
    .then(function (response) 
    {
        dispatch (
        {
            type: actionType.LIST,
            value: response.data
        })
    })
    .catch(err => 
    {
        
    });
};

export const getDetails = (id) => (dispatch, getState) =>
{   
    if(id > 0)
    {
        axios.get('agent_commission/details',{
            params: {
                "id": id,
                "country_id": getState().currentUser.data.country_id,
            }
        })
        .then(function (response) 
        {
            dispatch (
            {
                type: actionType.DETAILS,
                value: response.data
            })
        })
        .catch(function (error) 
        {
        
        });
    }
};

export const update = (data) => (dispatch, getState) =>
{
    // console.log(data);
    data.country_id = getState().currentUser.data.country_id;
    axios.post('agent_commission/update', data)
    .then(function (response) 
    {
      dispatch (
      {
        type: actionType.UPDATE,
        value: response.data
      })
    })
    .catch(err => 
    {
      
    });
};

export const store = (data) => (dispatch, getState) =>
{
    // console.log(data);
    data.country_id = getState().currentUser.data.country_id;
    axios.post('agent_commission/store', data)
    .then(function (response) 
    {
      dispatch (
      {
        type: actionType.STORE,
        value: response.data
      })
    })
    .catch(err => 
    {
      
    });
};


